import React from "react";
import Header from "../components/alva/Header";
import Hero from "../components/alva/Hero";
import TechStack from "../components/alva/TechStack";
import PainPoints from "../components/alva/PainPoints";
import Services from "../components/alva/Services";
import Method from "../components/alva/Method";
import WhyUs from "../components/alva/WhyUs";
import Marquee from "../components/alva/Marquee";
import FinalCTA from "../components/alva/FinalCTA";
import Footer from "../components/alva/Footer";
import SEO from "../components/alva/SEO";

const HOME_JSON_LD = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://alvadigital.fr/#organization",
    name: "Alva Digital",
    description: "Agence web parisienne spécialisée dans la création de sites internet pour artisans : plombiers, couvreurs, électriciens, menuisiers.",
    url: "https://alvadigital.fr",
    image: "https://alvadigital.fr/og-image.png",
    telephone: "+33-1-00-00-00-00",
    priceRange: "€€",
    address: {
        "@type": "PostalAddress",
        addressLocality: "Paris",
        addressCountry: "FR",
    },
    areaServed: { "@type": "Country", name: "France" },
    sameAs: [],
};

export default function Home() {
    return (
        <>
            <SEO
                title="alva digital — Agence web à Paris pour artisans"
                description="Agence web parisienne pour artisans (plomberie, couverture, électricité). Sites qui génèrent des demandes de devis. SEO local. Audit gratuit en 30 minutes."
                path="/"
                jsonLd={HOME_JSON_LD}
            />
            <main className="relative bg-[#F7F7F5] text-[#1A1A2E] overflow-x-hidden" data-testid="home-page">
                <Header />
                <Hero />
                <TechStack />
                <PainPoints />
                <Services />
                <Method compact />
                <WhyUs />
                <Marquee />
                <FinalCTA />
                <Footer />
            </main>
        </>
    );
}
